import i18next from 'i18next';

export const getFactorToConvertMetricToEntityUnit = (unit) =>
  unit === 'mL' || unit === 'g' ? 1000 : 1;

export const convertUnits = (unit, isMinified = false, count = 1) => {
  switch (unit) {
    case 'unit':
      return isMinified ? i18next.t('GENERAL.MINIFIED_UNIT') : i18next.t('GENERAL.UNIT', { count });
    case 'g':
      return isMinified ? 'kg' : 'Kg';
    case 'L':
      return isMinified ? 'ml' : 'mL';
    case 'Kg':
    case 'kg':
      return 'g';
    case 'mL':
    case 'ml':
      return 'L';
  }
};

export const convertEntityQuantityToInpulseUnit = (value, unit) => {
  switch (unit) {
    case 'unit':
      return value;
    case 'g':
    case 'mL':
    case 'ml':
      return value / 1000;
    default:
      return value;
  }
};

/**
 * Used in Production Planning:
 * inStock input for recipes is formatted in the recipe's base unit or in batch production unit.
 *
 * When batch production is used, the value can directly be multiplied by the recipe's unit quantity.
 * ex: recipe defined in g for 1552g. Input is formatted batch of 1.55kg => inputting 0.9 will result in 0.9 * 1552 = 1396.8g
 *
 * When batch production is not used, the value is simply converted to the recipe's base unit.
 * ex: recipe defined in g for 1552g. Input is by default in Kg => inputting 0.9 will result in 0.9 * 1000 = 900g
 *
 * @param {*} value
 * @param {*} unit
 * @returns
 */
export const convertInpulseUnitToEntityQuantity = (value, unit) => {
  switch (unit) {
    case 'unit':
      return value;
    case 'g':
    case 'mL':
      return value * 1000;
  }
};
